export * from './CommentRect2TextIcon';
export * from './CommentRect2TextIcon16Light';
export * from './CommentRect2TextIcon16Regular';
export * from './CommentRect2TextIcon16Solid';
export * from './CommentRect2TextIcon20Light';
export * from './CommentRect2TextIcon20Regular';
export * from './CommentRect2TextIcon20Solid';
export * from './CommentRect2TextIcon24Regular';
export * from './CommentRect2TextIcon24Solid';
export * from './CommentRect2TextIcon32Regular';
export * from './CommentRect2TextIcon64Regular';
